import React, { useContext } from 'react';
import { Navigate } from 'react-router';
import ToolkitsContext from '../ToolkitList/context';
import OperationContext from '../context';

const ToolkitPageSelector = () => {
  const {
    operation: { number, isEspf },
  } = useContext(OperationContext);
  const { toolkits } = useContext(ToolkitsContext);

  if (isEspf) {
    return <Navigate to={`/operations/${number}/toolkit/espf/list`} />;
  }

  const noDocuments = toolkits.length === 0 || toolkits.some((x) => x.documentList.length === 0);
  const url = noDocuments
    ? `/operations/${number}/toolkit/form`
    : `/operations/${number}/toolkit/list`;

  return <Navigate to={url} />;
};

export default ToolkitPageSelector;
